import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import {
  CollectionList,
  CollectionDetail,
  CollectionDisposal,
  CollectionDisposalHazard,
  Debug,
  Signature,
  DisposalSignature,
  Driver,
} from "./app/components/Pages/index";
import { establishSession, isDriverRole, redirectToFusionLogin } from "./auth";

export class Routes extends React.Component {
  constructor(props) {
    super(props);
    this.session = establishSession();
  }

  render() {
    if (!this.session) {
      redirectToFusionLogin();
      return null;
    }

    return (
      <Router>
        <Switch>
          <Route
            path="/driver"
            component={(props) =>
              isDriverRole() ? <Redirect to="/" /> : <Driver {...props} />
            }
          />
          <Route path="/debug" component={(props) => <Debug {...props} />} />
          <Route
            path="/detail/signature/:unique_id"
            component={(props) => <Signature {...props} />}
          />
          <Route
            path="/detail/:unique_id"
            component={(props) => <CollectionDetail {...props} />}
          />
          <Route
            path="/disposal"
            component={(props) => <CollectionDisposal {...props} />}
          />
          <Route
            path="/disposal-hazard"
            component={(props) => <CollectionDisposalHazard {...props} />}
          />
          <Route
            path="/disposal-signature/:unique_id"
            component={(props) => <DisposalSignature {...props} />}
          />
          <Route path="/" component={(props) => <CollectionList {...props} />} />
        </Switch>
      </Router>
    );
  }
}
